export default {
  inserted: function bind(el, binding, vnode) {
    vnode.componentInstance.focus();
  }
};
